import type { Step as RcStep } from '@sb/remote-control/types';

import { type ValidationRule, type RoutineView } from '../../types';
import { validateConditional } from '../../util/validators';

import { CanonicalStepRuleBase } from './base';
import type { CanonicalValidateArgs } from './base';

class WaitRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.Wait', 'Wait');
  }

  protected validate({ args, routine }: CanonicalValidateArgs): void {
    type WArgs = Extract<RcStep.Arguments, { argumentKind: 'Wait' }>;
    const a = args as WArgs;
    this.checkCondition(a, routine);
  }

  /**
   * Validate the wait condition against the routine.
   * Throws ActionRequiredError if invalid.
   *
   * @throws {ActionRequiredError}
   */
  private checkCondition(
    args: Extract<RcStep.Arguments, { argumentKind: 'Wait' }>,
    routine: RoutineView,
  ): void {
    if (!args.condition) return;
    const raw = args.condition;

    const parsed = typeof raw === 'string' ? JSON.parse(raw || '[]') : raw;

    // `validateConditional` expects Conditional[][] – a non-array value
    // (e.g. a single object) would silently bypass the for-loops inside.
    // Guard against that by treating non-array values as empty.
    const conditions = Array.isArray(parsed) ? parsed : [];

    validateConditional(conditions, routine);
  }
}

export const WaitValidation: ValidationRule = new WaitRule().toValidationRule();
